// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purpose-section p {
  padding-top: 16px;
}
.purpose-section .row-container {
  padding-top: 0;
  display: flex;
  justify-content: space-between;
}

.purpose-desc-section {
  width: 50%;
  padding-right: 35px;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .purpose-section .row-container {
    padding-top: 0;
  }
  .purpose-desc-section {
    padding-right: 16px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .purpose-section .row-container {
    flex-wrap: wrap;
  }
  .purpose-desc-section {
    width: 100%;
    padding-right: 0;
    padding-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/PurposePilot/PurposePilot.scss"],"names":[],"mappings":"AACI;EACE,iBAAA;AAAN;AAEI;EACE,cAAA;EACA,aAAA;EACA,8BAAA;AAAN;;AAGE;EACE,UAAA;EACA,mBAAA;AAAJ;;AAEE;EAEI;IACI,cAAA;EAAR;EAGE;IACE,mBAAA;EADJ;AACF;AAGE;EAEI;IACI,eAAA;EAFR;EAKE;IACE,WAAA;IACA,gBAAA;IACA,cAAA;EAHJ;AACF","sourcesContent":[".purpose-section{\r\n    p{\r\n      padding-top: 16px;\r\n    }\r\n    .row-container{\r\n      padding-top: 0;\r\n      display: flex;\r\n      justify-content: space-between;      \r\n    }\r\n  }\r\n  .purpose-desc-section{\r\n    width: 50%;\r\n    padding-right: 35px;\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n    .purpose-section{\r\n      .row-container{\r\n          padding-top: 0;\r\n      }\r\n    }\r\n    .purpose-desc-section{\r\n      padding-right: 16px;\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 768px) {\r\n    .purpose-section{\r\n      .row-container{\r\n          flex-wrap: wrap;\r\n      }\r\n    }\r\n    .purpose-desc-section{\r\n      width: 100%;\r\n      padding-right: 0;\r\n      padding-top: 0;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
